export default __webpack_public_path__ + "static/media/sowmz-beach.1d088212.jpg";